/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import CN from 'classnames';
import { Button, Input, SimpleSelect } from 'components/atoms';
import {
  useEditEnterprise,
  // useSaveVideo,
} from 'framework/api/methods';
import React, { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import isEmail from 'utils/isEmail';
import isPhoneNumber from 'utils/isPhoneNumber';

export interface EnterpriseUpdateProps {
  [x: string]: any;
}

export const EnterpriseUpdate: FC<EnterpriseUpdateProps> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const [formData, setFormaData] = useState({
    name: '',
    address: '',
    email: '',
    brn: '',
    phone: '',
    password: '',
    package: {
      value: '',
      label: '',
    },
  });

  const convertToLocalNumber = (phoneNumber: string) => {
    const str = String(phoneNumber);
    if (str.startsWith('94')) {
      return `0${str.slice(2)}`;
    }
    if (str.startsWith('0')) {
      return `${str}`;
    }
    return `0${str}`;
  };

  const { mutate: editEnterpriseMutate, isLoading: editEnterpriseIsLoading } = useEditEnterprise();

  const editEnterprise = () => {
    editEnterpriseMutate(
      {
        id: id?.toString() || '',
        enterpriseName: formData.name,
        email: formData.email,
        address: formData.address,
        password: formData.password,
        BRNumber: formData.brn,
        phone: formData.phone,
        packages: formData?.package?.value,
      },
      {
        onSuccess: async ({ data }: any) => {
          notify('Update enterprise successfully!', 'success');
          navigate(location.pathname, {
            state: {
              ...location.state,
              enterprise: {
                enterprise_name: formData.name,
                address: formData.address,
                br_number: formData.brn,
                email: formData.email,
                phone_number: formData.phone,

                password: formData.password,
              },
            },
            replace: true, // optional: prevents adding to history
          });
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  useEffect(() => {
    const ent = location?.state?.enterprise;
    setFormaData({
      name: ent.enterprise_name || '',
      address: ent.address || '',
      brn: ent.br_number || '',
      email: ent.email || '',
      phone: convertToLocalNumber(ent.phone_number) || '',
      password: ent.password || '',
      package: {
        value: ent.package || '',
        label: ent.package || '',
      },
    });
  }, [location?.state?.enterprise, id]);
  return (
    <div className="flex flex-col justify-center items-center w-full h-full p-8 overflow-y-auto">
      <div className="bg-[white] shadow-md px-10 py-4 flex flex-col w-1/2 h-fit rounded">
        <div className="flex w-full justify-center items-center h-fit text-[#C40D42]">
          Update Enterprise information
        </div>

        <div className="flex w-full h-full gap-x-5 mt-6">
          <div className="w-1/2 flex flex-col">
            <Input
              labelValue="Enterprises Name"
              inputClassName="!rounded"
              appearance="gray"
              value={formData.name}
              isRequired
              onChange={(e) => {
                setFormaData({
                  ...formData,
                  name: e.target.value,
                });
              }}
            />

            <Input
              labelValue="Business Register Number"
              inputClassName="!rounded"
              className="mt-2"
              appearance="gray"
              value={formData.brn}
              isRequired
              onChange={(e) => {
                setFormaData({
                  ...formData,
                  brn: e.target.value,
                });
              }}
            />

            <Input
              labelValue="Phone"
              inputClassName="!rounded"
              appearance="gray"
              className="mt-2"
              value={formData.phone}
              isRequired
              onChange={(e) => {
                const numericValue = e.target.value.replace(/\D/g, ''); // remove all non-digits
                setFormaData({
                  ...formData,
                  phone: numericValue,
                });
              }}
            />
          </div>

          <div className="w-1/2 flex flex-col gap-y-2">
            <Input
              labelValue="Address"
              inputClassName="!rounded"
              appearance="gray"
              isRequired
              value={formData.address}
              onChange={(e) => {
                setFormaData({
                  ...formData,
                  address: e.target.value,
                });
              }}
            />

            <Input
              labelValue="Email"
              inputClassName="!rounded"
              appearance="gray"
              isRequired
              value={formData.email}
              onChange={(e) => {
                setFormaData({
                  ...formData,
                  email: e.target.value,
                });
              }}
            />

            <div className="flex flex-col mt-0">
              <span className="text-[#737791] pb-1 text-sm">Packages</span>

              <div className="w-full">
                <SimpleSelect
                  isWhiteBg={false}
                  isDefault={false}
                  isShortMenu
                  isFormAppearance
                  options={[
                    { label: 'Package 1', value: 'Package 1' },
                    { label: 'Package 2', value: 'Package 2' },
                    { label: 'Package 3', value: 'Package 3' },
                    { label: 'Dialog', value: 'Dialog' },
                  ]}
                  value={formData.package?.value === '' ? null : formData.package}
                  onChange={(e) => {
                    setFormaData({
                      ...formData,
                      package: e,
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="flex w-full justify-center items-center h-fit text-[#C40D42] mt-3">
          Update Password
        </div>
        <div className="flex gap-x-2 relative w-1/2">
          <Input
            labelValue="Password"
            inputClassName="!rounded"
            appearance="gray"
            value={formData.password}
            onChange={(e) => {
              setFormaData({
                ...formData,
                password: e.target.value,
              });
            }}
          />

          <i
            className={CN(
              'ri-file-copy-2-line absolute bottom-2 -right-[30px] text-[24px] text-[#63717A] cursor-pointer',
              {
                hidden: formData.password === '',
              },
            )}
            onClick={() => {
              if (formData.password) {
                navigator.clipboard.writeText(formData.password);
                notify('Password copy to clipboard.', 'success');
              }
            }}
          />
        </div>

        <div className="mt-5 flex w-full justify-start items-start">
          <Button
            isRounded
            className=""
            isLoading={editEnterpriseIsLoading}
            disabled={
              !formData.name ||
              !formData.brn ||
              !formData.address ||
              !formData.email ||
              !formData.phone ||
              formData.package?.value === ''
            }
            onClick={() => {
              if (!isEmail(formData.email)) {
                notify('Invalid email address', 'error');
                return;
              }

              if (!isPhoneNumber(formData.phone)) {
                notify('Invalid phone number. Must be 10 digits.', 'error');
                return;
              }

              editEnterprise();
            }}
          >
            Update
          </Button>

          <Button
            isRounded
            appearance="secondary"
            className="ml-2 border-2"
            onClick={() => {
              navigate('/enterprises');
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EnterpriseUpdate;
